<div class="avatar-view">
  <img [ngStyle]="{height: size, width: size}" *ngIf="avatarUrl" [src]="avatarUrl" class="actors--avatar" />
  <img [ngStyle]="{height: size, width: size}" *ngIf="!avatarUrl" [src]="'/assets/image/avatar-default.png'" class="actors--avatar"/>
</div>